import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    windheight: '',
    iuId: localStorage.getItem('iuId') ? localStorage.getItem('iuId') : '',
    iuAccount: localStorage.getItem('iuAccount') ? localStorage.getItem('iuAccount') : '',

    iuName: localStorage.getItem('iuName') ? localStorage.getItem('iuName') : '',
    iuPost: localStorage.getItem('iuPost') ? localStorage.getItem('iuPost') : '',
  },
  mutations: {
    changeuser(state, user) {
      state.iuId = user.iuId.iuId;
      state.username = user.iuId.iuAccount;
      state.iuName = user.iuId.iuName;
      state.iuPost = user.iuId.iuPost;
      localStorage.setItem('iuId', user.iuId.iuId);
      localStorage.setItem('iuAccount', user.iuId.iuAccount);
      localStorage.setItem('iuName', user.iuId.iuName);
      localStorage.setItem('iuPost', user.iuId.iuPost);

    },
    getWindowHeight(state, data) {
      state.windheight = data.windheight;
    }
  },
  actions: {
  },
  modules: {
  }
})
